import { createContext, useCallback, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({
  theme: "dark",
  toggle: () => {},
});

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "dark";
    const stored = localStorage.getItem("tpf-theme");
    if (stored === "light" || stored === "dark") return stored;
    return "dark"; // default
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    // also tweak iOS status bar
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
      meta.setAttribute("content", theme === "dark" ? "#080d14" : "#f4f0e6");
    }
    try {
      localStorage.setItem("tpf-theme", theme);
    } catch (_) {
      /* private mode */
    }
  }, [theme]);

  const toggle = useCallback(
    () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    []
  );

  return (
    <ThemeContext.Provider value={{ theme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
